import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=6ea4b896&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"
import style0 from "./Education.vue?vue&type=style&index=0&id=6ea4b896&prod&lang=scss&scoped=true"
import style1 from "./Education.vue?vue&type=style&index=1&id=6ea4b896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4b896",
  null
  
)

export default component.exports